import React from 'react';
import ReservationSegmentCheckInGeneral from './ReservationSegmentCheckInGeneral';
import NoteTab from '../Notes/NoteTab';


export default class ReservationSegmentCheckInWorkspace extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return (
      <div className="tab-content">
        <ReservationSegmentCheckInGeneral {...this.props} />
        <NoteTab 
          notes_path={this.props.reservation_segment_notes_path}
          new_record={false}
          date_format={this.props.date_format}
          time_format={this.props.time_format}
          activeTab={this.props.activeTab}
          updateNoteCount={this.props.noteCount}
        />
        {this.renderPaymentTotalBanner()}
      </div>
    );
  };

  renderPaymentTotalBanner() {
    if (!this.props.incidental_taken || this.props.payment_due_amount && this.props.payment_due_amount != 0) {
      return (
        <div className="accommodations-price-footer">
          {
            !this.props.incidental_taken 
            ?
            <p className="lead" style={{ marginBottom: 0, display: 'inline-block', marginRight: '20px' }}>
              <label style={{ marginBottom: 0 }}>{I18n.t('incidental_auth_due')}:</label>&nbsp;
              {this.props.formatCurrency(this.props.incidental_deposit_due)}
            </p>
            :
            null
          }
          {
            this.props.payment_due_amount && this.props.payment_due_amount != 0
            ?
            <p className="lead" style={{ marginBottom: 0, display: 'inline-block' }}>
              <label style={{ marginBottom: 0 }}>{I18n.t('payment_due')}:</label>&nbsp;
              {this.props.formatCurrency(this.props.payment_due_amount)}
            </p>
            :
            null
          }
        </div>
      );
    } else {
      null
    }
  };

};